import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiV2 from "api-v2";

export const useCancelDisclaimer = (rfxId: number, evalId: number) => {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (memberId: number) =>
			apiV2.post(
				`/rfx/${rfxId}/evaluation/${evalId}/panel-members/${memberId}/disclaimer/cancel`
			),
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ["panel-members"] });
		},
	});
};
